import React, { ReactNode } from "react";
import styled from '@emotion/styled';
import { colors } from "src/theme";
import { MergeWithOverwrite } from "src/common";

const LabelStyle = styled.label((props: { color: string, disabled: boolean }) => ({
  color: props.disabled ? colors.text4 : props.color,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '20px',
  marginBottom: '4px',
  display: 'inline-block',
  verticalAlign: 'top',
}));

export type InputLabelProps = MergeWithOverwrite<React.LabelHTMLAttributes<HTMLLabelElement>, {
  color?: string;
  children: ReactNode;
  disabled?: boolean;
  className?: string;
}>;

export const InputLabel = ({ color = colors.text1, disabled = false, children, className }: InputLabelProps) => (
  <LabelStyle color={color} disabled={disabled} className={className}>
    {children}
  </LabelStyle>
);
